/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { History } from 'history';

import { IAppState } from 'src/store';
import { Button, Icon, IconClickable, Image, Text, View } from 'src/components/common';
import './styles.scss';
import DepositionDetailItem from 'src/components/DepositionDetailItem';
import DepositionSwichtableListView from 'src/components/DepositionSwichtableListView';
import SortingButton from 'src/components/common/SortingButton';
import { PATHS } from 'src/appConfig/paths';
import { Deposition, FileData, FileType, People } from 'src/dataFactory/depositionFactory';
import Loading from 'src/components/Loading';
import FileUpload from 'src/components/FileUpload';
import { MODAL_TYPES } from 'src/appConfig/modal';
import { modalActions } from 'src/redux/modalRedux';
import { ErrorService, Toastify } from 'src/services';
import { YesNoModalData } from 'src/components/Modal/YesNoModal';
import NewDeposition from '../NewDeposition';
import { getOrderedFiles, isSelectedAll, isSelected } from 'src/utils/fileUtils';
import { depositionAction } from 'src/redux/depositionRedux';
import { filesAction } from 'src/redux/fileRedux';
import { DeleteParam, GrantAccessFinalPayload, RenameFileParam } from 'src/redux/depositionRedux/types';
import { FilePreDownloadPayload } from 'src/redux/fileRedux/types';
import Hourglass from 'src/components/Hourglass';
import { IMAGES } from 'src/appConfig/images';
import AddParties from '../NewDeposition/AddParties';
import { getDateDisplay, getTimeDisplay } from 'src/utils/momentUtils';
import { RejectModalData } from 'src/components/Modal/RejectModal';
import AddAccessFinalParties from './AddAccessFinalParties';
import UploaderFilterButton from './UploaderFilterButton';

interface ParamTypes {
  id: string;
}
type DepositionFile = {
  exhibit: FileData[];
  final: FileData[];
  production: FileData[];
};
const DepositionDetail: React.FC<Props> = ({
  history,
  depositionFiles,
  isUploadDone,
  showModal,
  closeModal,
  onGetDepositionDetail,
  onDeleteDeposition,
  onCompleteDeposition,
  onGetDepositionRequester,
  onGetDepositionInvoledParties,
  onGetDepositionExhibit,
  onGetDepositionFinal,
  onGetDepositionProduction,
  onSetDepositionExhibit,
  onSetDepositionProduction,
  onSetDepositionFinal,
  onRenameFile,
  onDeleteFile,
  onSetUploadFiles,
  onSetUploadFileStatus,
  onResetUploadFile,
  onDownloadFiles,
  onApproveDeposition,
  onRejectDeposition,
  onLockDeposition,
  onGrantAccessFinalDeposition,
}) => {
  const { id } = useParams<ParamTypes>();
  const [isGridView, setIsGridView] = useState(true);
  const [deposition, setDeposition] = useState<Deposition>();
  const [orderOption, setOrderOption] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const [isAddFinalAccessParties, setIsAddFinalAccessParties] = useState(false);
  const [isShowAddParties, setIsShowAddParties] = useState(false);
  const [addedParties, setAddedParties] = useState<People[]>([]);
  const [isEditVisible, setIsEditVisible] = useState(false);
  const [selectedUploaderParty, setSelectedUploaderParty] = useState('all');

  const isActivedDeposition = ['active', 'completed'].includes(deposition?.status ?? '');
  const isLockedDeposition = deposition?.isLocked ?? false;

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (deposition?.id) {
      if (isUploadDone) {
        fetchFilesData(deposition);
      }
      setTimeout(() => {
        onSetUploadFileStatus(false);
        onResetUploadFile();
      }, 3000);
    }
  }, [isUploadDone]);

  useEffect(() => {
    if (deposition?.id && selectedUploaderParty) {
      onGetDepositionExhibit(
        {
          uri: deposition.subResources.exhibitUploaders.uri,
          params: { uploaderUserIds: selectedUploaderParty === 'all' ? undefined : selectedUploaderParty },
        },
        fetchExhibitSuccess,
        fetchDataFailed,
      );
    }
  }, [selectedUploaderParty]);
  const fetchData = () => {
    onSetDepositionExhibit([]);
    onSetDepositionFinal([]);
    onSetDepositionProduction([]);
    if (id) {
      onGetDepositionDetail({ uri: id }, fetchDataSuccess, _error => {
        handleBackToPrevious();
        return;
      });
    } else handleBackToPrevious();
  };

  const fetchFilesData = (deposition: Deposition) => {
    if (deposition?.id) {
      onGetDepositionExhibit(
        { uri: deposition.subResources.exhibitUploaders.uri },
        fetchExhibitSuccess,
        fetchDataFailed,
      );
      onGetDepositionFinal(
        { uri: deposition.subResources.finalDepositionFiles.uri },
        fetchFinalSuccess,
        fetchDataFailed,
      );
      onGetDepositionProduction(
        { uri: deposition.subResources.productionFiles?.uri },
        fetchProductionFilesSuccess,
        fetchDataFailed,
      );
    }
  };

  const fetchDataSuccess = (res: Deposition) => {
    setIsLoading(false);
    setDeposition(res);
    if (!['pending', 'rejected'].includes(res.status)) {
      fetchFilesData(res);
    }
    onGetDepositionRequester(
      { uri: res.subResources.requesterUserUri },
      requester => setDeposition({ ...res, requester: requester }),
      error => console.log('onGetDepositionRequester', error),
    );
    onGetDepositionInvoledParties(
      { uri: res.subResources.involvedPartiesUri },
      res => setAddedParties(res),
      fetchDataFailed,
    );
  };

  const fetchExhibitSuccess = (res: FileData[]) => {
    onSetDepositionExhibit(res);
  };
  const fetchFinalSuccess = (res: FileData[]) => {
    onSetDepositionFinal(res);
  };
  const fetchProductionFilesSuccess = (res: FileData[]) => {
    onSetDepositionProduction(res);
  };
  const fetchDataFailed = (error: any) => {
    setIsLoading(false);
    closeModal();
    ErrorService.handler(error);
  };

  const handleDeleteDeposition = () => {
    showModal({
      type: MODAL_TYPES.YES_NO_MODAL,
      data: {
        title: 'Delete Deposition',
        message: (
          <Text style={{ maxWidth: 502 }}>
            {`All files inside Exhibit Uploader and Final Deposition Files will be deleted permanently. Are you sure that you want to delete this "${deposition?.name}" deposition?`}
          </Text>
        ),
        onOk: () => {
          if (deposition) {
            onDeleteDeposition(
              { uri: deposition.uri },
              _res => handleBackToPrevious('Deposition has been deleted successfully!'),
              fetchDataFailed,
            );
          }
        },
        onCancel: closeModal,
        okText: 'DELETE',
        variant: 'danger',
      } as YesNoModalData,
    });
  };

  const handleCompleteDeposition = () => {
    showModal({
      type: MODAL_TYPES.YES_NO_MODAL,
      data: {
        title: 'Complete Deposition',
        message: <Text style={{ maxWidth: 502 }}>{`Are you sure want to complete this deposition?`}</Text>,
        onOk: () => {
          if (deposition) {
            onCompleteDeposition(
              { uri: deposition.uri },
              _res => {
                Toastify.success('Deposition has been completed successfully!');
                setDeposition({ ...deposition, status: 'completed' });
                closeModal();
              },
              fetchDataFailed,
            );
          }
        },
        onCancel: closeModal,
        okText: 'COMPLETE',
        variant: 'secondary',
      } as YesNoModalData,
    });
  };

  const handleCloseDetailModal = (reloadNeeded?: boolean, newData?: any) => {
    if (reloadNeeded && newData?.id && deposition) {
      const newDeposition: Deposition = {
        ...deposition,
        actualDepositionDate: getDateDisplay(newData.actualDate),
        actualDepositionTime: getTimeDisplay(newData.actualDate),
        caption: newData.caption,
        caseId: newData.caseId,
        circuitId: newData.circuitId,
        name: newData.name,
        openDate: getDateDisplay(newData.openDate),
      };
      setDeposition(newDeposition);
      setAddedParties(newData.addedParties ?? []);
    }
    setIsEditVisible(false);
  };
  const handleOpenLockDepositionModal = () => {
    showModal({
      type: MODAL_TYPES.YES_NO_MODAL,
      data: {
        title: deposition?.isLocked ? 'Unlock Repository' : 'Lock Repository',
        message: `Are you sure that you want to ${deposition?.isLocked ? 'unlock' : 'lock'} this repository?`,
        onOk: () => {
          handleLockDeposition();
        },
        onCancel: closeModal,
        variant: deposition?.isLocked ? 'secondary' : 'primary',
        okText: deposition?.isLocked ? 'UNLOCK' : 'LOCK',
      } as YesNoModalData,
    });
  };
  // ====================== Handlers ======================

  const handleConfirmDeleteModal = (files: FileData[], fileType: FileType) => {
    showModal({
      type: MODAL_TYPES.YES_NO_MODAL,
      data: {
        title: 'Delete File',
        message: (
          <Text>
            {`${files.length > 1 ? 'Those files' : 'This file'}  cannot be recovered after delete.`}
            <br />
            {`Are you sure that you want to delete ${
              files.length > 1 ? `${files.length} selected files` : `file '${files[0].name}.${files[0].extension}'`
            }?`}
          </Text>
        ),
        onOk: () => {
          handleDeleteFiles(files, fileType);
        },
        onCancel: closeModal,
      } as YesNoModalData,
    });
  };

  const handleBackToPrevious = (message?: string) => {
    if (!!message) {
      Toastify.success(message);
    }
    closeModal();
    history.push(PATHS.DepositionManagement);
  };
  const handleOpenEditModal = () => {
    setIsEditVisible(true);
  };
  const handleDeleteFiles = (files: FileData[], fileType: FileType) => {
    setIsLoading(true);
    const deleteFiles: string[] = files.map(file => file.uri);
    deleteFiles.forEach(file => {
      const payload: DeleteParam = { uri: file };
      onDeleteFile(
        payload,
        () => {
          Toastify.success('Files has been deleted successfully!');
          setIsLoading(false);
          const updatedFiles = depositionFiles[fileType].filter(f => {
            return !files.some(d => d.id === f.id);
          });
          updateFiles(updatedFiles, fileType);
          closeModal();
        },
        () => {
          Toastify.error('Files has been deleted failures!');
          setIsLoading(false);
        },
      );
    });
  };

  const handleLockDeposition = () => {
    if (deposition) {
      onLockDeposition(
        { uri: deposition.uri, action: deposition.isLocked ? 'UNLOCK' : 'LOCK' },
        (res: any) => {
          setDeposition({ ...deposition, isLocked: !deposition.isLocked });
          closeModal();
        },
        fetchDataFailed,
      );
    }
  };

  const handleRenameFile = (file: FileData, updateName: string, fileType: FileType) => {
    setIsLoading(true);
    const payload: RenameFileParam = { uri: file.uri, newName: `${updateName}.${file.extension}` };
    onRenameFile(
      payload,
      () => {
        setIsLoading(false);
        closeModal();
        Toastify.success('Files has been renamed successfully!');
        const updatedFiles = depositionFiles[fileType]?.map((item: FileData) =>
          item.id === file.id ? { ...item, name: updateName } : item,
        );
        updateFiles(updatedFiles, fileType);
      },
      fetchDataFailed,
    );
  };
  const handleDownloadFile = (file: FilePreDownloadPayload) => {
    setIsLoading(true);
    const downloadFiles: FilePreDownloadPayload[] = [file];
    onDownloadFiles(downloadFiles);
  };
  const handleDownloadFiles = (files: FileData[]) => {
    setIsLoading(true);
    const downloadFiles: FilePreDownloadPayload[] = files.map(file => ({
      downloadUri: file.downloadUri,
      fileName: `${file.name}.${file.extension}`,
    }));
    onDownloadFiles(downloadFiles);
  };
  const handleSelectAllFiles = (type: FileType) => {
    const updatedFiles = depositionFiles[type].map(file => ({ ...file, isSelected: true }));
    updateFiles(updatedFiles, type);
  };

  const handleDeselectAllFiles = (type: FileType) => {
    const updatedFiles = depositionFiles[type].map(file => ({ ...file, isSelected: false }));
    updateFiles(updatedFiles, type);
  };

  const handleSelectFile = (fileData: FileData, type: FileType) => {
    const updatedFiles = depositionFiles[type].map(file =>
      file.id === fileData.id ? { ...file, isSelected: !!!file.isSelected } : file,
    );
    updateFiles(updatedFiles, type);
  };

  const updateFiles = (files: FileData[], type: FileType) => {
    switch (type) {
      case 'exhibit':
        onSetDepositionExhibit(files);
        break;

      case 'final':
        onSetDepositionFinal(files);
        break;

      case 'production':
        onSetDepositionProduction(files);
        break;

      default:
        break;
    }
  };

  const handleUploadFilesChange = (files: any, type: FileType) => {
    onSetUploadFiles({ files, id, type });
  };

  const handleRejectDeposition = () => {
    showModal({
      type: MODAL_TYPES.REJECT_MODAL,
      data: {
        title: 'Reject Deposition',
        message: '',
        onOk: (value: string) => {
          if (deposition) {
            onRejectDeposition(
              { uri: deposition.uri, reason: value },
              (_res: any) => {
                closeModal();
                Toastify.success('Deposition has been rejected.');
                setDeposition({ ...deposition, status: 'rejected', rejectionReason: value });
              },
              fetchDataFailed,
            );
          }
        },
        onCancel: closeModal,
        okText: 'REJECT',
      } as RejectModalData,
    });
  };

  const handleCloseAddParties = () => {
    setIsShowAddParties(false);
  };
  const handleAddParties = (data: People[]) => {
    if (deposition) {
      setIsLoading(true);
      const involvedParties = [...data].map(user => user.id);
      onApproveDeposition(
        { uri: deposition.uri, approveData: { involvedParties: involvedParties } },
        () => {
          setDeposition({ ...deposition, status: 'active' });
          setAddedParties(data);
          handleCloseAddParties();
          setIsLoading(false);
        },
        fetchDataFailed,
      );
    }
  };

  const handleOpenGrantAccessModal = () => {
    setIsAddFinalAccessParties(true);
  };

  const handleAddAccesFinalParties = (data: People[]) => {
    const payload: GrantAccessFinalPayload = {
      updateAccessData: {
        involvedParties: data.map(p => ({
          userId: p.id,
          canAccessFinalDeposition: p.canAccessFinalDeposition ?? false,
        })),
      },
      uri: deposition?.uri ?? '',
    };
    onGrantAccessFinalDeposition(
      payload,
      () => {
        setAddedParties(data);
        Toastify.success('Grant parties access to final deposition successfully!');
        setIsAddFinalAccessParties(false);
      },
      fetchDataFailed,
    );
  };
  // Variables
  const filesView = (files: FileData[], type: FileType) => {
    const isLocked = deposition?.isLocked;
    const isMultiSelect = depositionFiles[type].filter(file => file.isSelected).length > 1;
    const orderFiles = getOrderedFiles(files, orderOption);
    // console.log(orderFiles)
    return (
      <View className="mt-16">
        <DepositionSwichtableListView
          isGrid={isGridView}
          isLocked={isLocked}
          files={orderFiles}
          isMultiSelect={isMultiSelect}
          fileType={type}
          status={deposition?.status}
          onSelectFile={(id, value) => {
            handleSelectFile(id, type);
          }}
          onDeleteFile={files => handleConfirmDeleteModal(files, type)}
          onRenameFile={(id, value) => {
            handleRenameFile(id, value, type);
          }}
          onDownloadFile={handleDownloadFile}
        />
      </View>
    );
  };

  const tabContent = (files: FileData[], type: FileType) => {
    const selectedFiles: DepositionFile = {
      exhibit: depositionFiles.exhibit.filter(e => !!e.isSelected) ?? [],
      final: depositionFiles.final.filter(e => !!e.isSelected) ?? [],
      production: depositionFiles.production.filter(e => !!e.isSelected) ?? [],
    };
    const isExhibitTab = type === 'exhibit';
    const isProductionTab = type === 'production';
    const isFinalTab = type === 'final';

    const exhibitFiles = depositionFiles.exhibit ?? [];
    const productionFiles = depositionFiles.production ?? [];
    const finalFiles = depositionFiles.final ?? [];

    const selectedFilesLength = selectedFiles[type].length;
    const getCorrectDepositionFiles = isExhibitTab
      ? exhibitFiles
      : isProductionTab
      ? productionFiles
      : isFinalTab
      ? finalFiles
      : [];
    return (
      <div className="columns is-1-mobile is-4-desktop ">
        <div className="column">
          <View className="ctn-depo-detail__files-col">
            <FileUpload onChange={(value: any) => handleUploadFilesChange(value, type)} />
            <View isRow justify="space-between">
              <View isRow>
                <IconClickable
                  className={`cmp-swicht-list-view ${isGridView ? 'cmp-swicht-list-view__active' : ''}`}
                  name="ic_grid"
                  disabled={isGridView}
                  onClick={() => setIsGridView(true)}
                />
                <IconClickable
                  className={`cmp-swicht-list-view ${!isGridView ? 'cmp-swicht-list-view__active' : ''}`}
                  name="ic_list"
                  disabled={!isGridView}
                  onClick={() => setIsGridView(false)}
                />
              </View>
              <View isRow className="ctn-depo-detail__actions">
                {selectedFilesLength > 0 && [
                  <Button
                    type="button"
                    variant="outline"
                    className="mr-16"
                    key={`delete-multi-${selectedFiles[type]}`}
                    onClick={() => {
                      handleConfirmDeleteModal(selectedFiles[type], type);
                    }}>
                    {`DELETE ${selectedFilesLength} FILE${selectedFilesLength > 1 ? 'S' : ''}`}
                  </Button>,
                ]}
                {selectedFilesLength > 0 && (
                  <Button
                    type="button"
                    variant="secondary"
                    onClick={() => {
                      handleDownloadFiles(selectedFiles[type]);
                    }}
                    className="mr-16"
                    key={`download-multi-${selectedFiles[type]}`}>
                    {`DOWNLOAD ${selectedFilesLength} FILE${selectedFilesLength > 1 ? 'S' : ''}`}
                  </Button>
                )}
                {!isSelectedAll(getCorrectDepositionFiles) && (
                  <Button
                    type="button"
                    variant="secondary-outline"
                    onClick={() => handleSelectAllFiles(type)}
                    className="mr-16"
                    key={`select-all-${selectedFiles[type]}`}>
                    SELECT ALL FILES
                  </Button>
                )}
                {isSelected(getCorrectDepositionFiles) && (
                  <Button
                    type="button"
                    variant="secondary-outline"
                    onClick={() => handleDeselectAllFiles(type)}
                    className="mr-16"
                    key={`deselect-all-${selectedFiles[type]}`}>
                    DESELECT ALL FILES
                  </Button>
                )}
                {isFinalTab && (
                  <Button
                    type="button"
                    variant="success"
                    onClick={() => {
                      handleOpenGrantAccessModal();
                    }}
                    className="mr-16"
                    key={`grant-access-${selectedFiles[type]}`}>
                    GRANT ACCESS
                  </Button>
                )}

                {isExhibitTab && (
                  <View isRow align="center" className="mr-16">
                    <UploaderFilterButton
                      onChange={value => setSelectedUploaderParty(value)}
                      involvedPaties={addedParties}
                      defaultOption={selectedUploaderParty}
                    />
                  </View>
                )}
                <SortingButton onChange={value => setOrderOption(value)} defaultOption={orderOption} />
              </View>
            </View>
            {isExhibitTab && filesView(exhibitFiles, type)}
            {isProductionTab && filesView(productionFiles, type)}
            {isFinalTab && filesView(finalFiles, type)}
          </View>
        </div>
        <div className="column is-one-quarter">
          {!!deposition?.id && <DepositionDetailItem data={{ ...deposition, involvedParties: addedParties }} />}
        </div>
      </div>
    );
  };

  const tabHeaderContent = (title: string) => {
    return (
      <Tab tabIndex={`tab-${title}`}>
        {isLockedDeposition && <Icon name="ic_lock" />} <span>{title}</span>
      </Tab>
    );
  };

  return (
    <View className="ctn-depo-detail">
      {!!deposition?.id ? (
        <View className="container" style={{ width: '100%' }}>
          {isAddFinalAccessParties && (
            <AddAccessFinalParties
              onClose={() => setIsAddFinalAccessParties(false)}
              onSaveData={handleAddAccesFinalParties}
              addedParties={addedParties}
            />
          )}
          {isShowAddParties && (
            <AddParties onClose={handleCloseAddParties} onSaveData={handleAddParties} addedParties={addedParties} />
          )}
          <Button
            variant="text"
            className={'back-previous-page mt-40'}
            icon={<Icon name={'ic_arrow_left'} />}
            onClick={() => {
              handleBackToPrevious();
            }}>
            VIEW ALL DEPOSITIONS
          </Button>
          <View className="mb-20" isRow justify="space-between" align="center">
            <Text size={36}>{deposition.name}</Text>
            {deposition?.status === 'pending' && (
              <View isRow>
                <Button
                  variant="secondary-outline"
                  onClick={() => handleRejectDeposition()}
                  className="ctn-depo-detail__btn-delete mr-16">
                  REJECT
                </Button>
                <Button variant="success" onClick={() => setIsShowAddParties(true)}>
                  MOVE TO ACTIVE
                </Button>

                {isEditVisible && <NewDeposition onClose={handleCloseDetailModal} deposition={deposition} />}
              </View>
            )}
            {['active', 'completed'].includes(deposition.status) && (
              <View isRow>
                {deposition.status !== 'completed' && (
                  <Button variant="secondary" onClick={handleCompleteDeposition} className="mr-16">
                    COMPLETE
                  </Button>
                )}
                <Button onClick={handleDeleteDeposition} className="ctn-depo-detail__btn-delete">
                  DELETE DEPOSITION
                </Button>
                {isActivedDeposition && (
                  <Button
                    onClick={handleOpenLockDepositionModal}
                    className="ml-16 mr-16"
                    variant="secondary-outline"
                    icon={<Icon name={deposition?.isLocked ? 'ic_unlock' : 'ic_lock'} className="mr-8" />}
                    iconPosition={'left'}>
                    {deposition?.isLocked ? 'UNLOCK REPOSITORY' : 'LOCK REPOSITORY'}
                  </Button>
                )}
                <Button variant="secondary" onClick={handleOpenEditModal}>
                  EDIT
                </Button>

                <View>
                  {isEditVisible && (
                    <NewDeposition
                      onClose={handleCloseDetailModal}
                      deposition={{ ...deposition, involvedParties: addedParties }}
                    />
                  )}
                </View>
              </View>
            )}
          </View>
          {['active', 'completed'].includes(deposition.status) ? (
            <Tabs>
              <TabList>
                {tabHeaderContent(`Exhibit uploader (${depositionFiles.exhibit.length})`)}
                {tabHeaderContent(`Production files (${depositionFiles.production.length})`)}
                {tabHeaderContent(`Final Deposition (${depositionFiles.final.length})`)}
              </TabList>
              <TabPanel className="mt-36">{tabContent(depositionFiles.exhibit, 'exhibit')}</TabPanel>
              <TabPanel className="mt-36">{tabContent(depositionFiles.production, 'production')}</TabPanel>
              <TabPanel className="mt-36">{tabContent(depositionFiles.final, 'final')}</TabPanel>
            </Tabs>
          ) : (
            <div className="columns is-1-mobile is-4-desktop ">
              <div className="column">
                <View className="box">
                  <View className="cmp-deposition-pending" justify="center" align="center">
                    {deposition.status === 'pending' && [
                      <Hourglass zoom={0.25} key="deposition-pending-icon" />,
                      <Text className="mt-16" key="deposition-pending-message" size={14}>
                        This deposition is pending for approval.
                      </Text>,
                    ]}
                    {deposition.status === 'rejected' && [
                      <Image src={IMAGES.iconDepositionRejected} key="deposition-pending-icon" />,
                      <Text className="mt-16" key="deposition-pending-title" size={14}>
                        This deposition was rejected by admin with reason:
                      </Text>,
                      <Text className="cmp-deposition-rejected-reason" key="deposition-pending-message" size={14}>
                        {deposition.rejectionReason ?? 'Unknown reason'}
                      </Text>,
                    ]}
                  </View>
                </View>
              </div>
              <div className="column is-one-quarter">{deposition.id && <DepositionDetailItem data={deposition} />}</div>
            </div>
          )}
        </View>
      ) : (
        <View isRow justify="center" className="mt-72">
          <View isRow justify="center" className="mt-72">
            {isLoading && (
              <View className="ctn-loading">
                <Loading loadingStyle={2} variant="primary" />
              </View>
            )}
          </View>
        </View>
      )}
    </View>
  );
};

type Props = ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps & { history: History };

const mapStateToProps = (state: IAppState) => ({
  depositionFiles: state.deposition.depositionFiles,
  currentUser: state.auth.user,
  isUploadDone: state.file.isUploadDone,
});

const mapDispatchToProps = {
  showModal: modalActions.showModal,
  closeModal: modalActions.closeModal,
  onGetDepositionDetail: depositionAction.getDepositionById,
  onDeleteDeposition: depositionAction.deleteDeposition,
  onCompleteDeposition: depositionAction.completeDeposition,
  onGetDepositionRequester: depositionAction.getDepositionRequester,
  onGetDepositionInvoledParties: depositionAction.getDepositionInvoledParties,
  onGetDepositionExhibit: depositionAction.getDepositionExhibitFiles,
  onGetDepositionProduction: depositionAction.getDepositionProductionFiles,
  onGetDepositionFinal: depositionAction.getDepositionFinalFiles,
  onSetDepositionExhibit: depositionAction.setDepositionExhibit,
  onSetDepositionFinal: depositionAction.setDepositionFinal,
  onSetDepositionProduction: depositionAction.setDepositionProduction,
  onRenameFile: depositionAction.renameFile,
  onDeleteFile: depositionAction.deleteFile,
  onSetUploadFiles: filesAction.setUploadFile,
  onSetUploadFileStatus: filesAction.setUploadDone,
  onResetUploadFile: filesAction.resetUploadFile,
  onDownloadFiles: filesAction.downloadFiles,
  onApproveDeposition: depositionAction.approveDeposition,
  onRejectDeposition: depositionAction.rejectDeposition,
  onLockDeposition: depositionAction.lockDeposition,
  onGrantAccessFinalDeposition: depositionAction.grantAccessFinalDeposition,
};

export default connect(mapStateToProps, mapDispatchToProps)(DepositionDetail);
